import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackClickedVideoLoopButton, useTrackClickedVideoQualityButton } from "@air/analytics";
import { memo, useMemo } from "react";
import { SettingsButton } from "~/components/AssetModalV2/Content/Footer/components/SettingsButton";
import { useVideoContentControlsContext } from "~/components/AssetModalV2/Content/VideoContentControlsContextProvider";
import { SelectedOptionIcon } from "~/components/AssetModalV2/Visualizer/VideoVisualizer/VideoVisualizerInner/shared/SelectedOptionIcon";
export const VideoSettingsButton = /*#__PURE__*/ memo(function VideoSettingsButton(param) {
    let { container, priorityOptions } = param;
    const { isVideoLooping, setIsVideoLooping, resolutionOptions, setCurrentResolutionIndex, currentResolutionIndex } = useVideoContentControlsContext();
    const { trackClickedVideoLoopButton } = useTrackClickedVideoLoopButton();
    const { trackClickedVideoQualityButton } = useTrackClickedVideoQualityButton();
    const options = useMemo(()=>[
            ...priorityOptions !== null && priorityOptions !== void 0 ? priorityOptions : [],
            {
                id: "video-quality",
                label: "VIDEO QUALITY",
                type: "title"
            },
            {
                id: "resolution Auto",
                label: "Auto",
                onSelect: ()=>{
                    setCurrentResolutionIndex(-1);
                    trackClickedVideoQualityButton();
                },
                suffix: currentResolutionIndex === -1 ? /*#__PURE__*/ _jsx(SelectedOptionIcon, {}) : null,
                type: "item"
            },
            ...resolutionOptions.map((res, index)=>{
                const resolution = Math.min(res.width, res.height);
                return {
                    id: "resolution ".concat(resolution, "}"),
                    label: "".concat(resolution, "p"),
                    onSelect: ()=>{
                        setCurrentResolutionIndex(index);
                        trackClickedVideoQualityButton();
                    },
                    suffix: index === currentResolutionIndex ? /*#__PURE__*/ _jsx(SelectedOptionIcon, {}) : null,
                    type: "item"
                };
            }),
            {
                id: "video-playback",
                label: "VIDEO PLAYBACK",
                type: "title"
            },
            {
                id: "loop-video",
                label: "Loop video",
                type: "item",
                onSelect: ()=>{
                    setIsVideoLooping(!isVideoLooping);
                    trackClickedVideoLoopButton();
                },
                suffix: isVideoLooping ? /*#__PURE__*/ _jsx(SelectedOptionIcon, {}) : null
            }
        ], [
        priorityOptions,
        currentResolutionIndex,
        resolutionOptions,
        isVideoLooping,
        setCurrentResolutionIndex,
        setIsVideoLooping,
        trackClickedVideoLoopButton,
        trackClickedVideoQualityButton
    ]);
    return /*#__PURE__*/ _jsx(SettingsButton, {
        options: options,
        container: container
    });
});
VideoSettingsButton.displayName = "VideoSettingsButton";
